<h4>Create a new account</h4>
<hr />
<br />
<form
    name="create-child-account-form"
    [formGroup]="userForm"
    (ngSubmit)="onSubmit()"
>
    <div class="form-container">
        <div class="row">
            <div class="col-md-5">
                <div class="form-group">
                    <label>Email Address </label>
                    <input
                        type="email"
                        formControlName="email"
                        autocomplete="off"
                        class="form-control"
                        name="email"
                        placeholder="Email"
                        maxlength="128"
                        [ngClass]="{ 'is-invalid': f.email.dirty && f.email.errors?.required|| submitted && f.email.errors?.email }"
                    />
                    <small
                        class="error"
                        *ngIf="emailInUseMessage"
                    >{{emailInUseMessage}}</small>
                    <small
                        class="error"
                        *ngIf="f.email.errors?.email"
                    >Please include an '@' in the email address</small>
                    <small
                        class="error"
                        *ngIf="f.email.dirty && f.email.errors?.required"
                    >Please enter .</small>
                </div>
                <div class="form-group" style="margin-bottom: 35px;">
                    <label>Password </label>
                    <input
                        type="password"
                        formControlName="password"
                        autocomplete="off"
                        class="form-control"
                        name="password"
                        placeholder="Password"
                        maxlength="128"
                        [ngClass]="{ 'is-invalid': f.password.dirty && f.password.errors?.required || submitted && f.password.errors?.pattern}"
                    />
                    <app-password-strength-meter [newPassword]="f.password.value"></app-password-strength-meter>
                    <small
                        class="error"
                        *ngIf="f.password.errors?.pattern"
                    >Must be at least 8 characters long and a mixture of numbers and letters.</small>
                    <small
                        class="error"
                        *ngIf="f.password.dirty && f.password.errors?.required"
                    >Please enter a password.</small>
                </div>
                <div class="form-group">
                    <label>Confirm Password </label>
                    <input
                        type="password"
                        formControlName="passwordConfirm"
                        autocomplete="off"
                        class="form-control"
                        name="passwordConfirm"
                        placeholder="Confirm Password"
                        [ngClass]="{ 'is-invalid': f.passwordConfirm.dirty && f.passwordConfirm.errors?.required || submitted && f.passwordConfirm.value != f.password.value}"
                    />
                    <small
                        class="error"
                        *ngIf="f.password.value && f.passwordConfirm.value && f.passwordConfirm.value != f.password.value"
                    >Please enter matching passwords.</small>
                    <small
                        class="error"
                        *ngIf="f.passwordConfirm.dirty && f.passwordConfirm.errors?.required"
                    >Please confirm your password</small>
                </div>
            </div>

            <div class="col-md-5">
                <div class="form-group">
                    <label>First Name </label>
                    <input
                        type="text"
                        formControlName="firstName"
                        class="form-control"
                        name="firstName"
                        placeholder="First Name"
                        maxlength="50"
                        [ngClass]="{ 'is-invalid': f.firstName.dirty && f.firstName.errors?.required }"
                    />
                    <small
                        class="error"
                        *ngIf="f.firstName.dirty && f.firstName.errors?.required"
                    >Please enter your first name.</small>
                    <small
                        class="error"
                        *ngIf="f.firstName.errors?.pattern"
                    >Only English characters are accepted.</small>
                </div>
                <div class="form-group">
                    <label>Middle Name</label>
                    <input
                        type="text"
                        formControlName="middleName"
                        class="form-control"
                        name="middleName"
                        placeholder="Middle Name"
                        maxlength="50"
                    />
                    <small
                        class="error"
                        *ngIf="f.middleName.errors?.pattern"
                    >Only English characters are accepted.</small>
                </div>
                <div class="form-group">
                    <label>Last Name </label>
                    <input
                        type="text"
                        formControlName="lastName"
                        class="form-control"
                        name="lastName"
                        placeholder="Last Name"
                        maxlength="50"
                        [ngClass]="{ 'is-invalid': f.lastName.dirty && f.lastName.errors?.required }"
                    />
                    <small
                        class="error"
                        *ngIf="f.lastName.dirty && f.lastName.errors?.required"
                    >Please enter your last name.</small>
                    <small
                        class="error"
                        *ngIf="f.lastName.errors?.pattern"
                    >Only English characters are accepted.</small>
                </div>
                <div class="form-group">
                    <label>Birth Date </label>
                    <input
                        type="date"
                        max="{{today | date:'yyyy-MM-dd'}}"
                        class="form-control"
                        formControlName="birthDate"
                        name="birthday"
                        placeholder="Click to select"
                        [ngClass]="{ 'is-invalid': f.birthDate.dirty && f.birthDate.errors?.required }"
                    />
                    <small
                        class="error"
                        *ngIf="f.birthDate.dirty && f.birthDate.errors?.required"
                    >Please enter your birthdate.</small>
                </div>
                <div class="form-group">
                    <label>Gender </label>
                    <select
                        class="form-control"
                        formControlName="gender"
                        name="gender"
                        [ngClass]="{ 'is-invalid': f.gender.dirty && f.gender.errors?.required }"
                    >
                        <option value="F">Female</option>
                        <option value="M">Male</option>
                        <option value="X">X</option>
                    </select>
                    <small
                        class="error"
                        *ngIf="f.gender.dirty && f.gender.errors?.required"
                    >Please enter your gender.</small>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <button
                    name="confirmationYesBtn"
                    class="btn btn-primary"
                    type="submit"
                >
                    CREATE CLIENT ACCOUNT
                </button>
            </div>
        </div>
    </div>
</form>
